import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { startStripeCheckout } from "../../actions/stripeActions";
import UserNav from "../UserDashboard/UserNav";

class CheckoutCancel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pendingCheckout: null
    };
    this.retryCheckout = this.retryCheckout.bind(this);
  }

  componentDidMount() {
    const pending = localStorage.getItem("pendingStripeCheckout");

    if (pending) {
      try {
        this.setState({
          pendingCheckout: JSON.parse(pending)
        });
      } catch (err) {
        localStorage.removeItem("pendingStripeCheckout");
      }
    }
  }

  retryCheckout() {
    if (this.state.pendingCheckout) {
      this.props.startStripeCheckout(this.state.pendingCheckout);
    }
  }

  render() {
    const { pendingCheckout } = this.state;

    return (
      <div>
        <UserNav />
        <div className="wrapper-alt">
          <div className="container checkout-result">
            <h1>Checkout canceled</h1>
            <p>Your card was not charged.</p>

            {this.props.errors && this.props.errors.message ? (
              <div className="alert alert-danger">{this.props.errors.message}</div>
            ) : null}

            <div className="checkout-actions">
              {pendingCheckout ? (
                <button className="btn btn-pp" onClick={this.retryCheckout}>
                  Try again
                </button>
              ) : null}
              <Link className="btn btn-secondary" to="/dashboard">
                Dashboard
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  errors: state.errors
});

export default connect(
  mapStateToProps,
  { startStripeCheckout }
)(CheckoutCancel);
